import React, { createContext, useContext, useState, useEffect } from 'react';

interface ValueContextProps {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}

const ValueContext = createContext<ValueContextProps | undefined>(undefined);

export const useValueContext = () => {
  const context = useContext(ValueContext);
  if (!context) {
    throw new Error('useValueContext must be used within a ValueContextProvider');
  }
  return context;
};

interface ValueContextProviderProps {
  children: React.ReactNode;
}

const ValueContextProvider: React.FC<ValueContextProviderProps> = ({ children }) => {
  const [value, setValue] = useState<number>(() => {
    const savedValue = localStorage?.getItem('valueContext');
    return savedValue !== null ? JSON.parse(savedValue) : 0;
  });

  useEffect(() => {
    localStorage?.setItem('valueContext', JSON.stringify(value));
  }, [value]);

  return (
    <ValueContext.Provider value={{ value, setValue }}>
      {children}
    </ValueContext.Provider>
  );
};

export default ValueContextProvider;